import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { BudgetUnitSearchProvider } from './context/budget-unit-search-context';
import { BudgetUnitSearchComponent } from './budget-unit-search-component';

export function BudgetUnitSearchFactory() {
    return (
        <BaseLayoutFactory>
            <BudgetUnitSearchProvider>
                <BudgetUnitSearchComponent />
            </BudgetUnitSearchProvider>
        </BaseLayoutFactory>
    );
}
